import { plainToClass } from 'class-transformer';
import { AxiosResponse } from "axios";


// tslint:disable: max-classes-per-file
export interface PaginatedResponse {
  content: any[];
  empty: boolean;
  last: boolean;
  number: number;
  size: number;
  totalPages: number;
  totalElements: number;
}

export class PaginatedResponseContent<T> {
  constructor(
  public data: T[],
  public page: number,
  public size: number,
  public last: boolean,
  public empty: boolean,
  public totalPages: number,
  public totalElements: number) {}
}

export function paginatedResponseContent<T>(responseData: PaginatedResponse, expectedType: new () => T): PaginatedResponseContent<T> { 
  return new PaginatedResponseContent<T>(
    plainToClass(expectedType, responseData.content),
    responseData.number,
    responseData.size,
    responseData.last,
    responseData.empty,
    responseData.totalPages,
    responseData.totalElements
  )
}

export interface ResponseContent<T>{
  data: T
}

export function responseContent<T>(clazz: new () => T) {
  return (responseData: AxiosResponse) => ({
    data: plainToClass(clazz, responseData.data)
  }) as ResponseContent<any>
}

// tslint:disable-next-line: no-empty-interface
export interface IFilter {
}

export class Page {
  constructor(
    public page: number,
    public size: number) {
  }
}
